import React, { useState, useEffect } from 'react';
import * as uuid from 'uuid';
import { GateEventTypeInternal } from '../../../../../../../data-access/gql-types/graphql';
import { OnOffChannelSettings } from '../../../../../../../modules/action-create/channel-settings/on-off';
import { GateDailyModeStateTask } from '../../../../../../../types';
import { useLavvaCreateActionContext } from '../../../context';
import { useTaskEdit } from '../../../hooks/use-task-edit';
import { DeviceTaskParams, SceneTaskType, Task } from '../../../types';

export const GateDailyModeSettings: React.FC = () => {
  const { channels, taskVariant } = useLavvaCreateActionContext();
  const [isOn, setIsOn] = useState<boolean>(false);
  const { task, finalizeDeviceTaskSubmit } = useTaskEdit();

  useEffect(() => {
    if (task) {
      const gateDailyModeTaskState = (task.taskParams as DeviceTaskParams)
        .state as GateDailyModeStateTask<GateEventTypeInternal>;

      setIsOn(gateDailyModeTaskState.action === GateEventTypeInternal.SetDailyModeOn);
    }
  }, [task]);

  const handleSubmit = () => {
    for (let i = 0; i < channels.length; i++) {
      const task: Task = {
        id: uuid.v4(),
        taskType: SceneTaskType.ChannelState,
        taskParams: {
          state: {
            action: isOn
              ? GateEventTypeInternal.SetDailyModeOn
              : GateEventTypeInternal.SetDailyModeOff,
          } as GateDailyModeStateTask<GateEventTypeInternal>,
          channel: channels[i],
          variant: taskVariant,
        } as DeviceTaskParams,
      };

      finalizeDeviceTaskSubmit(task, i === channels.length - 1);
    }
  };

  return <OnOffChannelSettings isOn={isOn} handleSubmit={handleSubmit} setIsOn={setIsOn} />;
};
